<div class="contains">
  <input #search matInput placeholder="{{ 'SEARCH' | translate }}"
         autocomplete="off"
         id="search"
         (keyup)="onSearch()"
         [(ngModel)]="searchValue"
  [autofocus]="true">
</div>

